import React from 'react'
import { createSectionArray, isRetakeComplete } from './parse'
import _ from 'lodash'

import greenDot from 'Assets/greenDot.svg'
import normalDot from 'Assets/normalDot.svg'

export function getCyuQuestions (activity, selectedSection, progress, skipValidation = false) {
  let goodQuestion
  const cyuQuestions = []

  _.each(activity.questions, function (question, index) {
    if (question.meta.lcrp_cyu_question === 'true' && question.questionType === 'MC' &&
        question.topic.topicId === selectedSection.topicIdInt &&
      (question.meta.ebook !== undefined && question.meta.ebook.indexOf(selectedSection.ebookUrl) > 0)) {
      // DEV NOTE: Commenting out the below conditional will fix the UI bug mentioned in MLLC-893
      // But it busts the CYU Modal functionality.
      if (progress && progress.cyuC && progress.cyuC.indexOf(index) !== -1 && skipValidation === false) {
        return
      }

      // everything checks out, we can use this question
      goodQuestion = question

      // populate the question with quiz stuff
      goodQuestion.pointsAvailable = calculateInitialPointsAvailable(activity.score, goodQuestion)
      goodQuestion.originalPointsAvailable = goodQuestion.pointsAvailable
      goodQuestion.pointsAchieved = 0
      goodQuestion.answered = []
      goodQuestion.hinted = []
      goodQuestion.numHelps = 0
      goodQuestion.firstAutoHint = false
      goodQuestion.takenContentHint = false
      goodQuestion.givenUp = false
      goodQuestion.answeredWrong = 0
      goodQuestion.completed = false
      goodQuestion.cyuIndex = index

      // add it to the pile
      cyuQuestions.push(goodQuestion)
    }
  })
  if (cyuQuestions.length === 0) {
    return false
  }

  return cyuQuestions
}

// curCard is a Question object
// check if answer is correct, then grade and score question and the overall learning activity
export function checkAnswer (score) {
  let isCorrect = false
  score.curCard.answered.push(score.curCard.userAnswerIndex)
  isCorrect = evaluateMcScAnswer(score.curCard)
  return isCorrect
}

export function evaluateMcScAnswer (question) {
  // set grade accordingly

  if (question.userAnswerIndex === question.correctAnswerIndex) {
    question.grade = 100
    question.completed = true
    return true
  } else {
    // mark this answer as incorrect
    question.grade = 0
    question.answeredWrong = 1
    return false
  }
}

export function calculateInitialPointsAvailable (score, curCard) {
  const defaultScore = -1
  let pointsAvailable = 0

  if (curCard.score > 0) {
    pointsAvailable = curCard.score
  } else if (defaultScore > 0) {
    pointsAvailable = defaultScore
  } else if (curCard.questionType === 'MC' || curCard.questionType === 'SC') {
    // MC/SC
    pointsAvailable = 5 + (10 * curCard.meta.level)
  } else {
    // FB
    pointsAvailable = 10 + (10 * curCard.meta.level)
  }

  // multiply by initialPointsReductionFactor -- prevention for cheating
  pointsAvailable *= score.initialPointsReductionFactor
  return pointsAvailable
}

export function getCyuQuestionsBySectionId (activity, sectionIdInt) {
  const { resultsArr } = createSectionArray(activity)
  let returnQuestions = false

  _.each(resultsArr, (section, index) => {
    if (section.sectionIdInt === sectionIdInt) {
      returnQuestions = section.cyuQuestions
    }
  })

  return returnQuestions
}

export function getCyuProgressDots (activity, selectedSection) {
  let i
  let greenDots = 0
  const returnDots = []
  const totalCyuQuestions = getCyuQuestions(activity, selectedSection, false, true)
  const totalDots = totalCyuQuestions ? totalCyuQuestions.length : 0

  if (totalDots === 1) {
    return false
  }

  if (isRetakeComplete(activity)) {
    greenDots = activity.lcrp.progress.rt[`s${selectedSection.sectionIdInt}`].cyuC.length
  } else {
    greenDots = activity.lcrp.progress.fa[`s${selectedSection.sectionIdInt}`].cyuC.length
  }

  for (i = 0; i < totalDots; i++) {
    if (i < greenDots) {
      returnDots.push(<object data-test-id={`greenDot-${i}`} data={greenDot} type="image/svg+xml" />)
    } else {
      returnDots.push(<object data-test-id={`normalDot-${i}`} data={normalDot} type="image/svg+xml" />)
    }
  }

  return (
    returnDots
  )
}
